<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="items"
            >
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: 'BpeInvoice',
    props: ["items"],
    data: () => ({
        headers: [
            {text: 'No.', value: 'no'},
            {text: 'วันที่ใบแจ้งหนี้', value: 'invoiceDate'},
            {text: 'เลขที่ใบแจ้งหนี้', value: 'invoiceNo'},
            {text: 'ยอดใบแจ้งหนี้', value: 'invoiceAmount'},
            {text: 'หมายเหตุ', value: 'remark'}
        ],
        dialog: false
    })
}
</script>